import { getAction, listAction } from "@/data/connection";
import { Image } from "@/components/blocks/image/image.class";
import { Suggestion } from "../classes/suggestion.class";

/**
 * Gets a center entry.
 */
export const getSuggestionEntry = function (value, slugOrId, recursive) {
    return getAction('suggestions', value, slugOrId, recursive).then(data => {
        if(data.data[0])
            return processEntry(data.data[0]);
        if(data.data)
            return processEntry(data.data);
    });
}

/**
 * Gets a list of centers.
 */
export const getSuggestionsList = function (recursive, page, perPage) {
    return listAction('suggestions', recursive, page, perPage).then(data => {
        return { content: processList(data.data), totalEntries: Number(data.headers["x-wp-total"]), totalPages: Number(data.headers["x-wp-totalpages"]) };
    });
}

/**
 * Process data.
 */
const processData = function (data) {
    let content = data.data;
    return content;
}

/**
 * Process Entry.
 */
const processEntry = function (data) {
    // console.log("SuggestionModel :: processEntry :: data -> ", data);

    let content = new Suggestion(data);

    if (content.image && content.image.length)
        content.image = new Image(content.image[0]);

    return content;
}

/**
 * Process List.
 */
const processList = function (data) {
    let content = data;

    content = content.map(value => {
        return processEntry(value)
    })

    return content;
}


// WEBPACK FOOTER //
// ./src/data/models/suggestion.model.js